import React from "react";
import Title from "./title";
import CharacteristicsItems from "./characteristic-items";

const MainCharacteristics = (props) => {
  return (
    <div>
      <Title {...props} />
      <div
        className="main-characterisctics"
        data-cy={(props && props.cyData) || ""}
      >
        <CharacteristicsItems {...props} />
      </div>
    </div>
  );
};

export default MainCharacteristics;
